const CollectionFilterPriceRange = (el, onChangeFilterParams) => {


  let filterParams = []


  const initialize = () => {
    el.querySelectorAll('input').forEach(input => {
      input.addEventListener('input', e => {
        const newFilterParams = filterParams.filter(kv => kv.key != e.target.name)
        if (!e.target.value || e.target.value.length <= 0) {
          onChangeFilterParams(newFilterParams)
        } else {
          onChangeFilterParams([...newFilterParams, {key: e.target.name, value: e.target.value}])
        }
      })
    })

    el.querySelector('button').addEventListener('click', () => {
      const newFilterParams = filterParams.filter(kv => !kv.key.startsWith('price_'))
      onChangeFilterParams(newFilterParams)
    })
  }


  const setFilterParams = (newFilterParams) => {
    filterParams = newFilterParams

    el.querySelectorAll('input').forEach(input => {
      input.value = filterParams?.find(kv => kv.key == input.name)?.value ?? null
    })
  }


  initialize()

  return {
    setFilterParams: setFilterParams
  }
}


export default CollectionFilterPriceRange
